export const SCREEN_SHARING_ERROR = 'SCREEN_SHARING_ERROR';
